import React from "react";
import {
  FooterContainer,
  FooterTop,
  FooterBottom,
  FooterGrid,
  FooterBrand,
  FooterLogo,
  FooterTagline,
  FooterSection,
  FooterHeading,
  FooterLinks,
  FooterLink,
  ContactGrid,
  ContactItem,
  SocialLinks,
  SocialIcon,
  Copyright,
  Divider,
} from "./Footer.style";
import trixie from "../../assets/trixie.png";
import fb from "./assets/fb.svg";
import ig from "./assets/in.svg";
import tiktok from "./assets/tiktok.svg";
import call from "./assets/call.svg";
import mail from "./assets/mail.svg";

const Footer = () => {
  const quickLinks = [
    { label: "Home", url: "/" },
    { label: "About Us", url: "/about" },
    { label: "Projects", url: "/projects" },
    { label: "Contact", url: "/contact" },
    { label: "Privacy Policy", url: "/privacy-policy" },
    { label: "Terms of Service", url: "/terms-of-service" },
  ];

  const socials = [
    { name: "Facebook", icon: fb, url: "https://www.facebook.com/profile.php?id=100086018196742" },
    { name: "Instagram", icon: ig, url: "https://www.instagram.com/trixiegroup/" },
    { name: "TikTok", icon: tiktok, url: "https://www.tiktok.com/@trixiesolar3" },
  ];

  const contacts = [
    {
      icon: call,
      label: "Phone",
      lines: [
        { text: "+234 803 423 1676", url: "tel:+2348034231676" },
        { text: "+234 805 305 6078", url: "tel:+2348053056078" },
      ],
    },
    {
      icon: mail,
      label: "Email",
      lines: [
        { text: "info@trixiegroup.com", url: "mailto:info@trixiegroup.com" },
      ],
    },
  ];

  return (
    <FooterContainer>
      <FooterTop>
        <FooterGrid>
          {/* Brand Section */}
          <FooterBrand>
            <FooterLogo src={trixie} alt="TrixieGroup & Association" />
            <FooterTagline>
              Your trusted partner for innovative solar energy solutions.
              Powering a sustainable future for Nigeria and beyond.
            </FooterTagline>
            <SocialLinks>
              {socials.map((social) => (
                <SocialIcon
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={`Visit our ${social.name} page`}
                >
                  <img src={social.icon} alt={social.name} />
                </SocialIcon>
              ))}
            </SocialLinks>
          </FooterBrand>

          {/* Quick Links */}
          <FooterSection>
            <FooterHeading>Quick Links</FooterHeading>
            <FooterLinks>
              {quickLinks.map((link) => (
                <FooterLink key={link.label} to={link.url}>
                  {link.label}
                </FooterLink>
              ))}
            </FooterLinks>
          </FooterSection>

          {/* Contact Info */}
          <FooterSection>
            <FooterHeading>Contact Us</FooterHeading>
            <ContactGrid>
              {contacts.map((contact) => (
                <ContactItem key={contact.label}>
                  <img src={contact.icon} alt={contact.label} />
                  <div>
                    {contact.lines.map((line, idx) => (
                      <a key={idx} href={line.url}>
                        {line.text}
                      </a>
                    ))}
                  </div>
                </ContactItem>
              ))}
            </ContactGrid>
          </FooterSection>

          {/* Locations */}
          <FooterSection>
            <FooterHeading>Our Offices</FooterHeading>
            <ContactGrid>
              <ContactItem>
                <span>📍</span>
                <div>
                  <strong>Head Office</strong>
                  <p>Ise Eledumare Shopping Complex,<br />Okebola off Iyana Ogunpa Road, Ibadan</p>
                </div>
              </ContactItem>
              <ContactItem>
                <span>🏢</span>
                <div>
                  <strong>Branch Office</strong>
                  <p>Road 2, Ire Akari Estate,<br />off Akala Express Road, Oluyole,<br />Ibadan, Nigeria</p>
                </div>
              </ContactItem>
            </ContactGrid>
          </FooterSection>
        </FooterGrid>
      </FooterTop>

      <Divider />

      <FooterBottom>
        <Copyright>
          © {new Date().getFullYear()} TrixieGroup & Association. All rights reserved.
        </Copyright>
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer;
